import { PagingInfo } from 'types/paging';
import { AssetTypes } from '../../../type';
import { useInjection } from './hook';
import { HeaderValidation } from '../../elements/HeaderValidation';
import { Stack, Typography } from '@mui/material';
import { TableCustom } from 'app/components/elements/TableCustom';
import { HEADER_ASSET_TYPES_TAB } from '../../../const';
import React, { memo } from 'react';
import { styled } from '@mui/material/styles';
import { TextEllipsis } from 'app/components/elements/TextEllipsis';
import { ModalAddNewTypes } from './ModalAddNewType';
import dayjs from 'dayjs';
import { DialogConfirm } from 'app/components/elements/DialogConfirm';

type RenderDataMapProps = {
  dataAssetTypes: AssetTypes[];
  onClickEditUser: (assetTypes: AssetTypes) => void;
  onClickDeleteUser: (assetTypes: AssetTypes) => void;
};
const renderDataAssetTypes = ({
  dataAssetTypes,
  onClickEditUser,
  onClickDeleteUser
}: RenderDataMapProps) => {
  return dataAssetTypes.map((data) => {
    return {
      name: {
        value: <TextEllipsis text={data?.name} width={'95%'} />
      },
      fields: {
        value: (
          <Typography style={{ width: '95%', whiteSpace: 'pre-line' }}>
            {data.assetEntries.map((item) => item.field.name).join(', ')}
          </Typography>
        )
      },
      createdAt: {
        value: <TextEllipsis text={dayjs(data?.createdAt).format('YYYY-MM-DD')} width={'95%'} />
      },
      actions: {
        value: (
          <Stack flexDirection={'row'} gap={'10px'} alignItems={'center'}>
            <img
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (data) {
                  onClickEditUser(data);
                }
              }}
              src={'/icons/icon_action_edit.svg'}
              alt={`icon_action_edit`}
            />
            <img
              style={{ cursor: 'pointer' }}
              onClick={() => {
                if (data) {
                  onClickDeleteUser(data);
                }
              }}
              src={'/icons/icon_action_delete.svg'}
              alt={`icon_action_delete`}
            />
          </Stack>
        )
      }
    };
  });
};

export type AssetTypeProps = {
  pagingInfo: PagingInfo;
  handleChangePage: (value: number) => void;
  handleSort: (orderBy: string) => void;
  sortOption: { field?: string; order?: string };
  onSearch: (value: string) => void;
  initSearchText: string;
  refreshDataAssetTypes: () => void;
  dataAssetTypes: AssetTypes[];
  onExport: (type: string) => Promise<void>;
};
export const AssetTypesTab = ({
  pagingInfo,
  handleChangePage,
  handleSort,
  sortOption,
  onSearch,
  dataAssetTypes,
  initSearchText,
  refreshDataAssetTypes,
  onExport
}: AssetTypeProps) => {
  const {
    searchText,
    asyncAddNewType,
    setSearchText,
    listButton,
    showModalAddNew,
    asyncEditType,
    typeEdit,
    setTypeEdit,
    asyncDeleter,
    idDelete,
    setIdDelete,
    onCloseModalAdd
  } = useInjection({ initSearchText, refreshDataAssetTypes, onExport });
  return (
    <WrapperTab>
      <HeaderValidation
        searchText={searchText}
        buttons={listButton}
        setSearchText={setSearchText}
        onSearch={() => onSearch(searchText)}
      />
      <Stack sx={{ marginTop: '30px', marginBottom: '30px' }}>
        <TableCustom
          onSortHeader={handleSort}
          sort={sortOption}
          data={renderDataAssetTypes({
            dataAssetTypes,
            onClickEditUser: (assetTypes: AssetTypes) => {
              setTypeEdit(assetTypes);
            },
            onClickDeleteUser: (assetTypes: AssetTypes) => {
              setIdDelete(Number(assetTypes.id));
            }
          })}
          headers={HEADER_ASSET_TYPES_TAB}
          handleChooseRow={() => {}}
          styledTableRow={{ cursor: ' default ' }}
          pagingInfo={pagingInfo}
          handleChangePage={handleChangePage}
        />
      </Stack>
      <ModalAddNewTypes
        onSubmit={asyncAddNewType}
        isOpen={showModalAddNew}
        onCloseModal={onCloseModalAdd}
      />
      <ModalAddNewTypes
        isEdit
        initData={typeEdit}
        onSubmit={asyncEditType}
        isOpen={!!typeEdit}
        onCloseModal={() => setTypeEdit(undefined)}
      />
      <DialogConfirm
        isOpen={!!idDelete}
        onClose={() => setIdDelete(undefined)}
        textTitle={'Delete Asset Types'}
        textButton={'Delete'}
        isDelete
        isIconClose
        textContent={'Are you sure you want to delete this asset types?'}
        onSubmit={asyncDeleter}
      />
    </WrapperTab>
  );
};

export const MemoAssetTypeTab = memo(AssetTypesTab);

const WrapperTab = styled(Stack)(() => ({
  width: '100%',
  marginTop: 20
}));
